import { AxiosResponse } from 'axios';

export const checkForDownload = (response: AxiosResponse): void => {
  if ('content-disposition' in response.headers) {
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches !== null && matches[1]) {
        const fileName = matches[1].replace(/['"]/g, '');
        downloadFile(response.data as Blob, fileName);
      }
    }
  }
};

export const downloadFile = (blob: Blob, fileName = 'download.csv'): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};
